@if (listOfItems != null) {
  @for(item of listOfItems; track item.id) {
    <div style="padding-left: 10px; padding-top:5px; padding-bottom: 5px;">
      <app-score-value [itemId]="item.id"></app-score-value>
      <span>&nbsp;&nbsp;&nbsp;</span> {{ item.data.name }}
    </div>
  }
}

<!--Versión anterior-->
<!-- <div *ngFor="let item of listOfItems$ | async " style="padding-left: 10px; padding-top:5px; padding-bottom: 5px;">
  <app-score-value [itemId]="item.id"></app-score-value> <span> </span>
  <span>&nbsp;&nbsp;&nbsp;</span> {{ item.data.name }}
</div> -->
